module.exports = __webpack_public_path__ + "static/media/map_marker_icon_active.a9e3cd18.svg";